import { defineStore } from "pinia";
import { useStorage } from "@vueuse/core";
import { client } from "../lib/api";
import { computed } from "vue";

export type AccessCode = {
  id: string;
  code: string;
  name: string;
  expires_at: string;
};

export const usePromoCodeStore = defineStore("promoCode", () => {
  const coupon = useStorage<AccessCode | null>("affinity_coupon_code", null);

  async function check(code: string) {
    try {
      const { data } = await client.put(
        `/payment/access_code?access_code=${code}`,
      );

      return data as AccessCode;
    } catch {
      /* empty */
    }

    return null;
  }

  const isValid = (coupon?: AccessCode | null) =>
    coupon && !!coupon.id && coupon.expires_at > new Date().toISOString();

  const hasAccessCode = computed(() => isValid(coupon.value));

  function remove() {
    coupon.value = null;
  }

  return {
    coupon,
    check,
    isValid,
    hasAccessCode,
    remove,
  };
});
